module.exports = __webpack_public_path__ + "img/dahamani_0.7220bbe9.jpg";